const en_US = {
    20: 'OPEN',
    24: 'Account under review',
    25: 'Account partially approved',
    27: 'Account failed review',
    30: 'Order submission',
    40: 'Order submission',
    50: 'Order processing',
    90: 'Order Cancelled',
    100: 'SC Order',
    240: 'Order pending processing',
    270: 'Account under review',
    280: 'Order submitted',
    300: 'NOT_STARTED',
    320: 'Order completed',
    800: 'Order under review',
    801: 'Order shipped',
    LEGACY: '',
    register: 'Register',
    supplyCenter: 'Supply Center',
    required: 'Required',
    accountNotExit: 'This phone number does not exist, please enter it again',
    passwordNotValid: 'This password is wrong, please enter it again',
    name: 'Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    institution: 'Institution',
    labOrDept: 'Dept',
    contactInformation: 'Contact',
    mobile: 'Mobile',
    phone: 'Phone',
    email: 'Email',
    shipToName: 'Ship To Name',
    shipToPhone: 'Ship To Phone',
    please_input_correct_phone_number:
        'Note: The format of the contact information you entered may be incorrect. If you are sure it is correct, please ignore this message.',
    shipToStateName: 'Province',
    shipToCityName: 'City',
    shipToStateId: 'Province',
    shipToCityId: 'City',
    shipToAddress: 'Address',
    billToName: 'Bill To Name',
    billToPhone: 'Bill To Phone',
    billToEmail: 'Bill To Email',
    invoiceTitle: 'Invoice Title',
    billToStateName: 'Province',
    billToCityName: 'City',
    billToStateId: 'Province',
    billToCityId: 'City',
    billToAddress: 'Address',
    code: 'Code',
    registerSuccess: 'Register Success',
    registerFailure: 'Register Failure',
    noticeOne: 'Note: All the following are required!',
    baseInfo: 'Basic Info',
    shipInfo: 'Ship To Info',
    billInfo: 'Bill To Info',
    sameShipInfo: 'Same as Ship To',
    errorMobile: 'Invalid Mobile',
    errorEmail: 'Invalid Email',
    duplicateEmail: 'This mailbox is already used',
    unusedEmail: 'Account does not exist,Please register a new account',
    receiveNotification:
        'I agree to receive information about Thermo Fisher Scientific products and services by phone, email, or otherwise',
    registerAccount: 'Register Account',
    noticeTwo:
        'Click the "register account" button to purchase products and services through this website, indicating that you have accepted and agreed to:',
    useClauses: 'Terms of Use',
    termsConditions: 'Terms & Conditions',
    thermofisher: 'Thermofisher Scientific',
    noticeThree:
        'Sales of the products and services you purchase from this website',
    privacy: 'Privacy Policy',
    pricingConsignment: 'Pricing and commission policy',
    getCode: 'Send Code',
    sendSuccess:
        'The verification code has been successfully sent to your mailbox',
    sendFailure:
        'The verification code cannot be received for this account. Please register a new account or contact CSR/ sales',
    loginSuccess: 'Login Success',
    loginFailure: 'Login Failure',
    isBindingEmail: 'Email has already been bound',
    invalidCode: 'Invalid Code',
    codeOverdue: 'Code has expired',
    enterEmail: 'Enter your email at Thermofisher website',
    noticeFour:
        'Tip: the verification code will be invalid after 2 hours. Please do not provide it to others!',

    ssoLoginLabel: 'SSO Login',
    accountLoginLabel: 'Account Login',

    selectProduct: 'Select Product',
    cancel: 'Cancel',
    addToShoppingCart: 'Add to Cart',
    enterProductName: 'Enter ProductName/SKU',
    allProduct: '全部商品',
    canShip: 'Deliverable',
    moreDetails: 'Product Details',
    productDetails: 'Product Details',
    getInfo: 'I get it',
    shipTo: 'ShipTo',
    shippingAddress: 'ShipTo Address',
    billAddress: 'BillTo Address',
    setDefault: 'Set Default',
    setTemporaryST: 'Select shipping address',
    showDeliveryAddress: 'Deliver to:',
    setDefaultAddress: 'Set Default Address',
    sku: 'SKU',
    product_name: 'Product Name',
    modify: 'Modify',
    expectDeliveryDateTitle: 'Modify CRD',
    refund_sku: 'SKU',
    refund_lot: 'Lot',
    inventory: 'Inventory',
    specifications: 'Unit Size',
    storeCondition: 'Store Condition',
    listPrice: 'List Price',
    shoppingCart: 'Shopping Cart',
    moreThermofisherProduct: 'More Products from Thermofisher website',
    clickMeToContinueSearching: 'Click me to continue searching',
    pleaseContinueIfNotFound: 'Please continue if not found',
    selectCustomer: 'Select Customer',
    searchCustomer: 'Enter Subject/Name/ShipTo/Email',
    searchB2bPlatformCustomer: 'Enter Subject/ShipTo',
    notFoundCustomer: 'No related users found',
    noShiptoCustomer: 'View other unbound clients',
    billOverdue: 'Account is frozen',
    telephone: 'Consignee Telephone',
    inventoryWarning: 'Inventory is subject to the actual situation!',
    default: 'Default',
    scName: 'SC Name',
    scNumber: 'sc No',
    orderConfirmation: 'Order Confirmation',
    consignee: 'Consignee',
    poNumber: 'PO(No)：',
    poNumberTF: 'TF PO(No)：',
    discountCode: 'Quote:',
    note: 'Note:',
    noteTF: 'Note:',
    apply: 'Apply',
    productInfo: 'Product Info',
    chooseOtherAddress: 'Choose Other Address',
    shipToConsignee: 'Receiver',
    billToConsignee: 'Receiver',
    submitOrderFailure: 'Order submission failed',
    updateShipmentPhoneInformationReminder:
        'Reminder: The SMS notification phone number must be either the recipient contact information or the default contact information for the account. Please check and update the selected contact information.',
    replenishmentMgmt: 'Replenishment management',
    feedback: 'Feedback',
    pleaseEnter: 'Enter',
    pleaseSelect: 'Select',
    beginTime: 'Start',
    endTime: 'End',
    district: 'Area',
    abnormalDescription: 'Abnormal Description',
    approvalDescription: 'Approval Description',
    lotNo: 'Lot No',
    expireDate: 'Expire Date',
    expectShipDate: 'Expected delivery time:',
    TfsType: 'TFS',
    scChangeTfsTypeMessage:
        'This product {0} has exceeded the stock limit and will automatically be converted to website logistics.',
    quickAddSkuValue: 'SKU',
    quick_add_sku_success: 'Quickly add products have been added to cart',
    sku_is_not_null: 'Sku cannot be empty',

    TfsProductSearch: 'Thermo fisher website product search',
    inputProductNameAndSKU: 'Input product name/sku',
    apply_associated_supply_center: 'Apply for associated supply center',
    demo_site_order_add_shopping_cart: 'Add shopping cart',
    quickly_add_product: 'Quickly add product',
    shopping_cart_quickly_add_product: 'Quickly add cart',
    demo_site_add_sku_button: 'Add SKU',
    demo_site_delete_sku_row_button: 'Delete',
    quickly_batch_add_product_need_three_sku:
        'Quickly add products to keep at least three lines',
    input_sku_duplicate: 'Duplicate SKU entered',
    enter_information_at_least_one_sku: 'Enter at least one SKU information',
    tfs_sku_not_pricr_not_sales:
        'SKU on the official website has no price and is not allowed to be sold',
    quickly_add_sku_no_sku: 'sku:{0} not exist',
    quickly_add_sku_is_fsbio:
        'This product does not currently support proxy ordering.',
    no_search_sku_result:
        'A product matching the search term could not be found',
    please_use_precision_search:
        'Please use exact article number or English keyword search',
    please_use_quickly_add_sku_function:
        'Please try the "Quick Add Product" function below',
    invalid_shipTo: 'Invalid shipTo',
    other_division_no_perssion:
        'This product belongs to {0}. You have no more permission to view. If you have more questions, please contact the associated stock center Admin for feedback.',

    activity_more_details: 'More Details',
    activity_pick_up: 'Pick Up',
    activity_introduce: 'Activity Introduction',
    activity_details: 'Activity Details',

    product_more_details: 'View Details',
    proudct_details: 'Product Details',
    product_sku: 'SKU',
    product_sku_colon: 'SKU:',
    product_specifications: 'Unit Size',
    product_specifications_colon: 'Unit Size:',
    product_add_to_shopping_cart: 'Add Cart',
    product_infomation: 'Product Infomation',
    porduct_discount_price: '(Discount Price)',
    porduct_quote_price: 'Discount Price:',
    porduct_total_quantity: 'Total: {0}',
    porduct_quote_details: 'Quote Details',
    porduct_discount: 'Discount:',
    porduct_min_quantity: 'Min:',
    quote_icon: '促',
    quote_details: 'Quote Details',
    porduct_shopping_cart_used: '*Please go to the shopping cart to use quote',
    porduct_search_history: 'Search History',
    product_view_items: 'View available items',
    product_eta: 'Estimated time stock',
    product_estimated_ship_date: 'Estimated Ship Date',
    product_crd_date: 'CRD',
    product_crd_date_current: 'Current CRD',
    product_crd_date_new: 'New CRD',
    order_product_group_shipped: 'Shipped',
    order_product_group_not_shipped: 'Not Shipped',
    order_date_range: 'Date Range:',
    order_date_range_not_available: 'No available date range',
    crd_select_to_modify: 'Select rows to modify',
    order_invoice_title: 'Invoice',
    order_invoice_important_reminder: 'Important Reminder:',
    order_invoice_important_reminder_rule_1:
        'Please follow the latest version of <<',
    order_invoice_important_reminder_rule_2:
        'Thermo Field China Sales Order Entry System',
    order_invoice_important_reminder_text:
        '>>to check whether all the supporting documents for purchase are available.',

    order_invoice_important_reminder_rule_title_new:
        'When the order amount exceeds the entry exemption line',
    offline_order_invoice_important_reminder_rule_title_new:
        'When the order amount exceeds the entry exemption line, You are required to upload the following invoice documentation during order submission.',
    offline_order_invoice_important_reminder_rule_title_new_part1:
        'This order amount has exceeded the entry exemption line (i.e., RMB 60,000). You are required to upload the following entry documents during order submission',
    offline_order_invoice_important_reminder_rule_title_new_part2:
        '(Contract/PO).',
    offline_order_invoice_important_reminder_total_limit_exceed_part1:
        'You have not added any required entry documents. If you do not add the required contract documents in time, the order will remain locked and cannot proceed to the next process. You can choose:',
    offline_order_invoice_important_reminder_total_limit_exceed_part2:
        'Return to the order confirmation page to add the required contract/PO documents.',
    offline_order_invoice_important_reminder_total_limit_exceed_part3:
        'If you currently do not have any documents to provide, please promptly supplement the required contract documents in the order details page of the stock center after submitting the order.',

    order_invoice_offline_reminder: 'Important Reminder',
    order_invoice_important_reminder_rule_1_1_new: 'Please follow the《',
    order_invoice_important_reminder_rule_1_2_new: 'Sales order entry system',
    order_invoice_important_reminder_rule_1_3_new:
        'Ensure that the entry support documents are complete',
    order_invoice_important_reminder_rule_1_4_new:
        ',And must be signed with the customer',
    order_invoice_important_reminder_rule_1_5_new:
        'Double chapter sales contract',
    order_invoice_important_reminder_rule_1_6_new: '》,',
    order_invoice_important_reminder_rule_1_7_new: '.',

    order_invoice_important_reminder_rule_2_1_new:
        'When shipping address changes, please follow the company《',
    order_invoice_important_reminder_rule_2_2_new:
        'Delivery address change policy',
    order_invoice_important_reminder_rule_2_3_new: '》，',
    order_invoice_important_reminder_rule_2_4_new:
        'Provide the required address confirmation documents',
    order_invoice_important_reminder_rule_2_5_new: '.',

    order_invoice_important_reminder_rule_3_1_new:
        'If there is any problem, contact financial internal control department in time.',

    order_invoice_important_reminder_text_new:
        '》核查所有入单支持文件是否均已齐备。',

    order_po_number_colon: 'PO(No):',
    order_remark_colon: 'Remark:',
    order_ship_info: 'Receiving Information',
    order_consignee: 'Receiver',
    order_contact: 'Contact',
    order_address: 'Address',
    order_subject: 'Dept',
    order_delivery_a: 'Delivery',
    order_delivery_method: 'Delivery Method',
    order_delivery_method_colon: 'Delivery Method:',
    order_self_take:
        'Please contact the host in advance to book the actual pick-up time',
    order_delivery_message: 'The goods will be delivered within 2 workdays',
    order_stock_delivery_message:
        'Products in stock are expected to be delivered within 2 working days',
    order_host: 'HOST',
    order_inventory_colon: 'Inventory:',
    order_submit_order_again:
        'May cause the order information to change,Please go to the order list and place a new order',
    order_confirm_select: 'Confirm selection',
    order_no_name: 'No',
    order_total_colon: 'Total:',
    order_next_step: 'Next',
    order_submit_order: 'Submit',
    order_confirm_information_again: 'Reconfirm the information',
    order_complete_confirm: 'Confirm and submit the order',
    order_complete_confirm_new:
        'All incoming supporting documents are available to confirm the submission of the order',
    order_confirm_submit: 'Confirm Submit',
    order_sumbit_success: 'Order submitted successfully',
    order_number_colon: 'OrderID:',
    order_sc_order_number: 'SC OrderID：',
    order_global_order_number: 'TF OrderID：',
    order_fone_order: 'F1 Order',
    order_my_order: 'My Order',
    order_global_delivery: 'Delivery by the website logistics',
    order_your_preferential_price: '(Your Discount Price)',
    order_preferential_price: '(Preferential Price)',
    order_list_price: '(List Price)',
    order_global_price: '(Webonly Price)',
    order_discount_price: '(Discount Price)',
    order_please_confirm: 'Please confirm：',
    order_r_quote_please_confirm:
        "You have one or more items in your cart that qualify for our special online offer pricing. This pricing can't be combined with R quotes in this cart.",
    order_r_quote_info: 'Prompt：Do you want to apply the promo quote?',
    order_contact_us: 'Contact Us',
    order_contact_service: 'Please contact customer service',
    order_phone_colon: 'TEL：',
    order_service_mobile: '4008208982(Mobile)',
    order_service_phone: '8008208982(TEL)',
    order_service_mail: 'Email：',
    order_service_mail_details: 'cssh@lifetech.com',
    order_save_colon: 'Save:¥ {0}',
    order_sc_product_delivery:
        '(Specialist delivery, may arrive within one day if available)',
    order_sc_stock_product_delivery:
        '（Specialist delivery, may arrive within one day if available）',
    order_global_product_delivery:
        '(Delivery by official website and uncertain delivery time)',
    order_global_serach_result: 'TFS website search',
    order_search_no_result:
        'No related products found, please contact us for details',
    order_search_tf_no_result:
        'No result? Please use SKU or English keywords to search',
    order_service_hot_line: 'HOTLINE:',
    need_help_contact_us: 'If you need help, please contact us',
    contact_telephone_one: '400 820 8982',
    contact_telephone_two: '800 820 8982',
    order_service_hot_line_number: '8008208982',
    order_service_hot_line_number_two: '4008208982',
    order_business_consult: 'Consulting:',
    order_business_consult_email: 'supplycenterchina@thermofisher.com',
    order_appoint_delivery:
        'Please contact the delivery manager in advance to make an appointment for the actual pick-up time',
    order_choose_other_address: 'Other address >',
    order_self_pick_up: 'Self pick up',
    order_self_other: 'other',
    order_self_express: 'express',
    host_full_receive: 'Receive',
    host_full_ReceiveConfirm: 'Please confirm Receive?',
    order_delivery: 'Delivery',
    order_sc_delivery_details: 'The goods will be delivered within 2 workdays',
    order_details: 'Order Details',
    order_preview: 'Preview',
    order_sign_receipt: 'Sign Receipt',
    order_express_number: 'ExpressNumber',
    order_sign_date: 'Sign Date',
    order_cancel_order: 'Cancel Order',
    order_partial_receipt: 'Partial Receipt',
    order_full_receipt: 'Full Receipt',
    order_buy_again: 'Buy Again',
    order_confirm_cancel_order: 'Confirm to cancel the order?',
    order_confirm: 'Confirm',
    order_cancel_order_by_service:
        'Website delivery order needs to contact customer service to cancel.',
    order_quote_order_by_service_customer:
        'This order contains specifica code, and can not be canceled, please contact sales and CSR',
    order_quote_order_by_service:
        'This order contains specifica code, and can not be canceled, please contact CSR',
    order_service_email: 'Email：cssh@thermofisher.com',
    order_not_upload_sign_receipt: 'No receipt has been uploaded',
    order_partial_receipt_confirm: 'Partial receipt confirmation',
    order_full_receipt_confirm: 'All receipt confirmation',
    order_current_shippment_number_colon: 'Actual quantity this time:',
    order_confirm_receive: 'Confirm Receipt',
    order_number: 'OrderID',
    order_purchase_date: 'Date',
    order_eone_number: 'E1 No',
    order_eone_status: 'E1 Status',
    order_eone_hold: 'E1 Hold',
    order_total_amount: 'Price',
    order_customer_order: 'Customer Order',
    order_ship_to_number: 'ShipTo',
    order_same_supply_center: 'Same as SC',
    order_type_placeholder: 'Please select the order type',
    order_status_placeholder: 'Please select order status',
    order_purchase_date_placeholder: 'Please select the purchase date',
    order_tm_query_Key_error: 'The keyword is no less than 3 characters',
    order_discount_code: 'Discount Code',
    order_wharehouse: 'Wharehouse',

    shopping_cart_delete_button: 'Delete',
    shopping_cart_cancel: 'Cancel',
    shopping_cart_current_sc: 'SC: {0}',
    shopping_cart_choose_preferential_type: 'Type',
    shopping_cart_discount_price: 'Discount Price',
    shopping_cart_discount_price_message:
        'System will show the quote applied price for you',
    shopping_cart_global_price: 'Webonly Price',
    shopping_cart_global_group_best_price: 'Group best price',
    shopping_cart_group_best_price_message:
        'System will choose best price from P/D quote price/ WOP price/list price.',
    shopping_cart_clear: 'Clear',
    f1_order_receive_select_all: '全选',
    shopping_cart_select_all: 'All',
    shopping_cart_settle: 'Checkout({0})',
    shopping_cart_delete: 'Delete({0})',
    shopping_cart_apply_failure:
        'Failed to apply quote,Please contact the administrator',
    shopping_cart_close: 'Close',
    shopping_cart_add_hot_recommended:
        'Recommended products have been added to cart',
    shopping_cart_empty: 'Your shopping cart is still empty',
    shopping_cart_s_quote_remove:
        'Please confirm all the related sku has been removed',
    shopping_cart_confirm_msg_one: 'Apply{0}',
    shopping_cart_confirm_msg_two: 'will add below skus to the cart',
    shopping_cart_change_shipment: 'Change shipment',
    shopping_cart_currently_no_match_condition_sku:
        'There are currently no match condition sku.',
    shopping_cart_apply_m_quote_message:
        'The applicable products for M Quote are only available for bulk delivery. You may choose to place a separate order for M Quote applicable products and other products. Please confirm if you would like to apply this promotional code.',
    shopping_cart_error_code_E1PQ40_message:
        'Quote applied failed, This quote could not be applied as the price of this promo code is higher than the WOP price.',
    shopping_cart_error_code_E1PQ35_message:
        'The promo/quote is invalid for the item(s) or quantities in the cart.',
    shopping_cart_assayid_placeholder: 'Please input Assay ID',
    shopping_cart_assayid_checked: 'Checked',
    shopping_cart_invalid_assayId: 'Invalid AssayId',
    shopping_cart_empty_assayId: 'Missing product attribute: Assay ID',

    current_shippment_quantity_colon: 'Delivered Qty',
    shippment_quantity_colon: 'Received Qty:',
    not_shippment_quantity_colon: 'Pending Qty:',
    shippment_current_inventory_colon: 'Current Inventory',
    shippment_confirm_delivery_amount: 'Confirm shipment quantity',
    shippment_express_number_colon: 'ExpressNumber:',
    shippment_order_details: 'Order Details',
    shippment_order_number: 'OrderID',
    shippment_eone_number: 'E1 No',
    shippment_eone_status: 'E1 Status',
    shippment_purchase_date: 'Date',
    shippment_cancel_date: 'Cancel Date',
    shippment_delivery_order: 'Ship Orde',
    shippment_sign_receipt: 'Receipt',
    shippment_preview: 'Preview',
    shippment_upload_again: 'Upload Again',
    shippment_edit_upload: 'Edit',
    shippment_express_number: 'ExpressNumber',
    shippment_sign_date: 'Sign Date',
    shippment_delivery_date: 'Delivery Date',
    shippment_expect_ship_date: 'Expected delivery time',
    shippment_cancel_order: 'Cancel Order',
    shippment_temporary_not_delivery: 'Delay Delivery',
    shippment_temporary_all: 'All',
    shippment_temporary_not_shipped: 'Not Shipped',
    shippment_temporary_pending_shipped: 'Shipping Available',
    temporary_not: 'Delay Delivery',
    shippment_delivery: 'Delivery',
    shippment_take_goods: 'Receiving',
    shippment_upload_signature_method_title: 'Signature Method',
    shippment_upload_signature_send_delivery_code:
        'Send the delivery code to the customer',
    shippment_upload_signature_method_select:
        'Please choose the customer receiving method:',
    shippment_upload_signature_method_customer: 'Customer Signed',
    shippment_upload_signature_method_delegate: 'Sign at Designated Location',
    shippment_upload_signature_method_sms_tip:
        'The system will send a delivery code to phone',
    shippment_upload_signature_method_tel: 'Tel:',
    shippment_upload_signature_method_email: 'Email:',
    shippment_upload_signature_method_send_info:
        'If the customer cannot receive SMS or email, you can also guide the customer to obtain the delivery code through the Thermo Fisher mobile order logistics.',
    shippment_upload_signature_method_send_code: 'Send Code',
    shippment_upload_signature_method_code_sent: 'Delivery code sent',
    shippment_upload_signature_method_sentto_code: 'Receipt code sent to',
    shippment_upload_signature_method_input_label:
        'Please enter the delivery code:',
    shippment_upload_signature_method_input_label_input_hint:
        'After you receive the code, please enter code:',
    shippment_upload_signature_method_input_placeholder: 'Enter delivery code',
    shippment_upload_signature_method_input_hint:
        'After you receive the code, fill it in here.',
    shippment_upload_designated_location: 'Upload designated location',
    shippment_upload_click_designated_location_by_photo:
        'Click take a photo and upload the product placement image',
    shippment_upload_recipient_mobile_number_cannot_be_empty:
        "The recipient's mobile number cannot be empty.",
    shippment_upload_signature_method_sent_delivery_code: 'Send receipt code',
    shippment_upload_signature_method_code_not_resent:
        'Delivery code not resent yet',
    shippment_upload_send_code_success: 'Verification code sent successfully',
    shippment_upload_send_code_failure: 'Failed to send verification code',
    shippment_upload_send_code_tel_incorrect:
        'Invalid phone number. Please check.',
    shippment_upload_send_code_status_incorrect:
        'The order status is not pending receipt.',
    shippment_upload_product_placement_photo: 'Placement Photo',
    shippment_upload_receive_code: 'Receive Code',

    shippment_not_upload_sign_receipt: 'No receipt has been uploaded',
    shippment_upload_sign_receipt: 'Upload receipt',
    shippment_upload_sign_receipt_by_photo:
        'Please take photos and upload the receipt',
    shippment_upload_sign_receipt_by_photo_here:
        'Click here to take a photo and upload the receipt',
    shippment_upload_other_photos: 'Upload other photos',
    shippment_other_photos: 'Other photos',
    shippment_upload_other_photos_here:
        'Click here to upload other photos (multiple allowed)',
    shippment_upload_other_photos_selected: 'Selected {0}/{1}',
    shippment_upload_other_photos_add: 'Add',
    shippment_upload_other_photos_limit:
        'You can upload up to {0} other photos',
    shippment_not_upload_other_photos: 'No other photos uploaded',
    shippment_upload_other_photos_failed: 'Upload failed',
    shippment_confirm_upload: 'Confirm to upload',
    shippment_confirm_cancel_order: 'Confirm to cancel the order?',
    shippment_confirm: 'Confirm',
    shippment_confirm_temporary_delivery: 'Confirm To Delay',
    shippment_if_temporary_delivery: 'Do you confirm to postpone the delivery?',
    shippment_see_temporary_delivery_list:
        'It can be viewed in the delay delivery list',
    shippment_confirm_wait_delivery: 'Confirm To wait delivery',
    shippment_if_wait_delivery: 'Do you confirm to wait the delivery??',
    shippment_see_wait_delivery_list:
        'It can be viewed in the wait delivery list',
    notification_already_wait_query_deliver_list:
        'wait shipment, you can check it in the pending shipment list！',
    shippment_self_pick_up: 'Self pick up',
    shippment_receiver: 'Consignee',
    shippment_contact: 'Contact',
    shippment_remark: 'Remarks',
    shippment_eone_number_hyphen: 'E1 No',
    shippment_all_order: 'All Orders',
    shippment_total_pieces: 'Total: {0}',
    shippment_serveral_times: 'Times {0}',
    shippment_inventory_logistics_information:
        'Inventory and E1 delivery details',
    shippment_details_shipment_number: 'Shipment No',
    shippment_details_backorder_date: 'Available Date',
    shippment_details_actual_ship_date: 'Delivery Date',
    shippment_details_shippment_state: 'Status',
    shippment_details_shippment_quantity: 'Shipped Qty',
    shippment_recommended_list: 'Recommend',
    shippment_all_available: 'All Available',
    shippment_partial_shipping: 'Partial Deliver',
    shippment_not_shipping: 'Not Shipment',
    shippment_add_tracking_number: 'Add track number',
    shippment_b2b_casmart_btn: 'Shipping Order',
    shippment_b2b_shipping_order_message:
        'To print the Kasama delivery note for this order, please download it from the "Pending Receipt Orders" section after printing the shipping order.',
    shippment_query_coa: 'Query COA',
    shipment_coa_analysis_certificate: 'COA Certificate of Analysis',
    shipment_coa_application_repeat: 'COA Application',
    shipment_coa_sku: 'SKU',
    shipment_coa_batch_no: 'Lot',
    shipment_coa_no_data: 'No COA data found',
    shipment_coa_no_data_prefix:
        'Sorry, we could not find a matching COA for this search.',
    shipment_coa_lot_null_prefix:
        'Please note: If the lot of the SKU is empty, you cannot request a COA.',
    shipment_coa_apply_now: 'Request COA Now',
    shipment_coa_download: 'Download',
    shipment_coa_query_more: 'Query More',
    shipment_coa_apply_dialog_title: 'Request COA',
    shipment_coa_apply_dialog_desc: 'Do you want to request a COA now?',
    shipment_coa_apply_success:
        'The COA request notification email has been sent successfully',
    shipment_coa_apply_failed:
        'Failed to send the COA request notification email',
    shipment_coa_loading: 'Loading COA...',
    shipment_coa_catalog_number_empty: 'No SKU is available for this shipment',
    shipment_coa_query_failed: 'Failed to query COA',
    shippment_punch: 'Punch',
    shippment_punch_success: 'Punch Success',
    shippment_exception_punch_success: 'Exception punch success.',
    shippment_exception_punch_status_is_not_null:
        'The abnormal punch-in status cannot be empty',
    shippment_punch_position_is_not_null:
        'The client coordinates cannot be empty',
    shippment_refresh_map: 'Refresh',
    shippment_more_than_punch_scope: 'You have exceeded the punch limit',
    shippment_not_punch: 'You are not punch in. You can not punch in yet',
    shippment_inaccurate_positioning_system:
        'Inaccurate positioning of the system',
    shippment_forget_punch: 'Forgot Punch',
    shippment_customer_pickup: 'Customer Pickup',
    shippment_permission_disabled:
        'You have disabled the location permission. You need to enable the location permission for the device',
    shippment_punch_exception_other: 'Other',
    shippment_punch_exception_other_type: 'Please input remark.',
    shippment_upload_signed_first_punch:
        'Please punch in before uploading the receipt                                   ',
    shippment_exception_punch: 'Exception punch',
    shippment_customer_feedback: 'Customer Feedback',
    shippment_customer_feedback_success: 'Add customer Feedback success',
    shippment_input_tracking_number: 'Input track number',
    shippment_please_input_tracking_number: 'Please input track number',
    shippment_update_tracking_number_success:
        'The tracking number has been updated successfully！',
    shippment_select_lot_and_quantity: 'Select lot and quantity',
    shipment_lot: 'Lot:',
    shipment_recommended_label: 'Recommended',
    shipment_cannot_be_null: 'Shipment package is not null',
    shipment_quantity_out_current_inventory: 'Quantity out current inventor',
    shipment_all_lot: 'All Lot',
    shipment_confirm_delivery: 'Confirm Delivery?',
    shipment_sku_incorrect: 'SKU {0} the delivered quantity is not suitable',
    shipment_delivery: 'Confirm delivery({0})',
    shipment_delivery_infor: 'Delivery Infor',
    shipment_details: 'Package Details',
    shippment_delivery_details: 'Delivery Detail',
    shippment_delivery_id: 'Delivery Id',
    shippment_shipped_express_number: 'Express Number',
    shipment_sku_lot: 'Lot',
    shipment_cancel_time: 'Cancel Time',
    shipment_cancel_quantity: 'Cancel Quantity',
    shipment_wait_quantity: 'Wait shipped quantity',
    shipment_received_date: 'Received Date',
    shipment_delivered_package_count: '{0} packages have been delivered',
    shipment_unread_message: 'You have an unread message. Please handle it.',
    shipment_fold_info: 'Fold Info',
    shippment_accompany_goods: 'Order Related',

    shipment_my_order_picking: 'My order picking',
    shipment_pick_list: 'Pick List',
    shipment_pick_not_shippment_quantity_colon: 'Not Quantity',
    shipment_pick_expiry_date: 'Expiry Date',
    shipment_pick_expand_less: 'Expand Less',
    shipment_pick_expand_more: 'Expand More',
    shipment_pick_all_expand_less: 'All expand less',
    shipment_pick_all_expand_more: 'All expand more',
    shipment_preview_pick_list: 'Preview pick list',
    shipment_pick_delete: 'Delete',
    shipment_pick_all: 'All',
    shipment_pick_please_select_pick_order:
        'Please select the pick to be deleted.',
    shipment_pick_delete_pick_order_success: 'Delete pick order success',
    shipment_pick_confirm_delete_pick_order: 'Confirm delete pick list',
    shipment_pick_is_confirm_delete_pick_order: 'Confirm delete pick list?',
    shipment_preview_pick_order: 'Pre-picking',
    shipment_pick_confirm_preview_pick_order: 'Confirm pre-picking',
    shipment_pick_is_confirm_preview_pick_order: 'Confirm pre-picking?',
    shipment_preview_pick_order_success: 'Pre-picking success',
    shipment_preview_pick_order_sku_shipment_is_null:
        'SKU shipping list is empty',
    shipment_preview_pick_order_sku_is_null: 'SKU list cannot be empty',
    shipment_pick_please_select_preview_pick_order_sku:
        'Please select the SKU that requires pre-picking.',
    shipment_preview_more: 'More',
    shipment_preview_delivered_quantity_greater_than__undelivered_quantity:
        '{0} the shipped quantity is greater than the unshipped quantity',
    shipment_preview_order_non_existent: 'Order does not exist',
    shipment_preview_inconsistent_order_status: 'Order status does not match',
    shipment_preview_inconsistent_order_type: 'Order type does not match',
    shipment_preview_lock_or_review_order: 'Order review may be locked',
    shipment_preview_order_has_been_picked: 'Order picked',
    shipment_preview_no_component_sku: 'Some sku under kit are missing',
    shipment_preview_component_quantity_incorrect: 'Incorrect number of sku',
    shipment_preview_component_suit_incorrect:
        'The number of component sets is inconsistent',
    shipment_preview_ship_quantity_zero: 'The number of a certain sku is 0',
    shipment_preview_ship_quantity_incorrect:
        'The shipped quantity is greater than the unshipped quantity',
    shipment_order_shippe_separately: 'Whether the order is shipped separately',
    shipment_picking_order_is_separately_shipment:
        'The order is already on the pick list. If you still insist on a separate shipment, the order will be removed from the pick list',
    shipment_pick_please_select_shipment_pick_order:
        'Please select the pick list to be shipped.',
    shipment_pick_order_has_unread_message:
        'The order have unread message , please read it before ship.',
    shipment_pick_order_inventory_less_than_quantity_shipped:
        'The inventory is less than the quantity shipped.',
    shipment_pick_please_select_recommended_product:
        'Please select the pick list to be recommended.',
    shipment_pick_batch_recommended_product:
        'Confirm the batch printing of recommended items',
    shipment_pick_confirm_batch_recommended_product:
        'Confirm the batch printing of recommended product?',
    shipment_pick_confirm_batch_pick_order_preview:
        'Confirm batch printing pick list',
    shipment_pick_confirm_batch_pick_order_pdf:
        'Confirm batch printing pick list？',
    shipment_pick_please_select_pick_order:
        'Please select the pick list to be printed.',
    shipment_pick_you_have_unread_message_please_read:
        'You have an unread message. Please handle it',
    shipment_pick_message_list_title: 'Message List',
    shipment_pick_message_list_button_next: 'Next',
    shipment_pick_order_num: 'Order Num',
    shipment_pick_update_address_to: 'Change address to',
    shipment_pick_to: 'to',
    shipment_pick_message_count: '{0} the message',
    shipment_list_special_tags: 'Special Tags',
    shipment_list_special_tags_other_desc: 'Other Information',

    my_order_on_hold: 'Order Onhold',
    my_order_on_hold_already_success: 'Shipment suspended successfully',

    supply_center_suspended_business:
        'Current supply center suspended business, order products will be delivered by the website logistics',

    host_abnormal_record: 'Abnormal Reagent Records',
    host_abnormal_lot_nubmer_colon: 'LOT No：',
    host_abnormal_nubmer_colon: 'No:',
    host_abnormal_expire_date_colon: 'Expiration Date：',
    host_abnormal_exception_specification_colon: 'Description：',
    host_abnormal_approval_status_colon: 'Approval Status：',
    host_abnormal_approved: 'Approved',
    host_abnormal_rejected: 'Rejected',
    host_abnormal_pending_approval: 'Approval Pending',
    host_abnormal_add: 'Add',
    host_abnormal_reagent_add: 'Add Abnormal Reagent',
    host_abnormal_exception_details: 'Exception Details',
    host_abnormal_amount: 'Quantity',
    host_abnormal_upload_photo: 'Upload Photo Credentials',
    host_abnormal_upload_photo_save: 'Upload Photo Credentials',
    host_abnormal_upload_here:
        'Click here to take photo and upload credentials',
    host_abnormal_selece_scName: 'Please select the supply center',
    host_abnormal_selece_lot: 'Please select the lot',
    host_abnormal_confirm_add: 'Confirm To Add',
    abnormal_scrapSort: 'Scrap Type',
    host_abnormal_scrap_sort_placeholder: 'Please select the scrap type',
    abnormal_f1OrderNumber: 'F1 Order Number',
    host_abnormal_f1_order_number_placeholder:
        'Please select the F1 order number',
    abnormal_DnOrderNumber: 'Express Number',
    host_abnormal_dn_order_number_placeholder:
        'Please select the express number',
    host_abnormal_valid_F1_order_number: 'Please enter a valid F1 order number',
    host_abnormal_Invalid_F1_Number: 'Invalid F1 Number',
    host_abnormal_No_Shipment: 'No Shipment',
    host_abnormal_Mismatch_SC_F1Number: 'Mismatch SC F1Number',
    host_abnormal_Empty_Sc: 'Empty Sc',
    host_abnormal_No_Match_SC_F1_Number: 'No Match SC F1 Number',
    host_abnormal_true_number: 'true F1 Number',
    host_abnormal_Empty_f1_number: 'Empty F1 Number',
    host_abnormal_f1_number_null: 'Not Exist F1 Number',
    host_abnormal_express_number_null: 'Not Exist F1 Number',
    host_abnormal_express_number_no: 'Empty Express Number',
    host_abnormal_scrap_greater_receiving: 'Quantity Over Received',
    host_abnormal_sku_lot_matching: 'No Match SKU_LOT',

    host_fone_order_details: 'Order Details',
    host_fone_shippement_information: 'Received Information',
    host_fone_replenishment_amount_colon: 'Replenishment Qty:',
    host_fone_receive_amount_colon: 'Received Qty:',
    host_fone_order_number: 'OrderID',
    host_fone_e1_order_number: 'F1 No',
    host_fone_order_status: 'F1 Status',
    host_fone_replenishment_date: 'Replenishment Date',
    host_fone_replenishment_amount: 'Replenishment Qty',
    host_fone_receive_date: 'Receive Date',
    host_fone_receive_amount: 'Received Qty',
    host_fone_cancel_date: 'Cancel Date',
    host_fone_received_amount: 'Received Qty:',
    host_receipt: 'Received',
    host_full_receipt: 'Full Receipt',
    host_receive_package_condition: 'Package Condition',
    host_receive_not_package_condition:
        'There is no parcel condition for this order',
    host_receive_select_sku: 'Please select this SKU',
    host_receive_select_batch_sku: 'Please select the SKU to receive',
    host_receive_invalid_quantity: 'Quantity received cannot be 0',
    host_shipment_status: 'Shipment Status',
    host_express_number: 'Express Number',
    host_logistics_company: 'Logistics Company',
    host_sku_type_of_number: 'Sku type number',
    host_tobe_shipped_quantity: 'Quantity',
    host_product_sku: 'Product Sku',
    host_wait_quantity: 'Wait Quantity',
    host_product_specifications: 'Product Specifications',
    host_lot_information: 'Lot Information',
    host_package_receive: 'Received',
    host_confirm_receive: 'Confirm received package？',
    host_completed_status: 'Completed',
    host_incompleted_status: 'Incompleted',
    user_center_advent_products: 'Advent Products',
    user_center_hold_products: 'Hold Products',
    user_center_your_message: 'My Message',
    user_center_clocked_signed: 'clocked and signed',
    user_center_punch_signed: 'Punch Signed',
    user_center_signed: 'signed',
    user_center_close: 'Close',
    user_center_long_desc_detail: 'Detailed notification description',
    user_center_notification_desc: 'Notification Description',
    shipment_punch_exception: 'Punch Exception',
    clocked_signed_success:
        'You are {0} away from your destination. You are within the punch range.',
    clocked_signed_failed:
        'You are {0} away from the destination, do not punch in range, punch out failed.',
    shipment_punch_host_checkin:
        'This order has an attached task, please pay attention.',

    host_advent_products_details_header: 'Hold past due products management',
    host_advent_products_item: 'Item: ',
    host_advent_products_expired_quantity: 'Expired Quantity: ',
    host_advent_products_type: 'Scrap Type: ',
    host_advent_products_f1Number: 'F1 Number: ',
    host_advent_products_expressNumber: 'Express Number: ',
    host_advent_products_advent_quantity: 'Advent Quantity: ',
    host_advent_products_dnsa: 'DNSA: ',
    host_advent_products_expiration_date: 'Expiration Date: ',
    host_advent_products_lot: 'Lot: ',
    host_advent_products_upload: 'Tag Upload',
    host_advent_products_confirm_upload_tag: 'Confirm upload tag',
    host_advent_products_advent_tag: 'Advent Tag: ',
    host_advent_products_upload_tag_is_not_null: 'Upload label not null',
    host_advent_product_specifications: 'Product Specific: ',
    host_advent_abnormal_label: 'Abnormal Label',
    sku_is_not_in_same_sc: 'target and source sku is not in same sc',
    host_internal_callout_order: 'Callout',
    host_internal_callin_order: ' Callin',
    enter_orderNo_sku_supply_center: 'Enter the OrderID/SKU/supply center',
    host_internal_withdrawal: 'Revert',
    host_update_tracking_number: 'Update track number',
    host_tracking_number: 'Tracking Number',
    host_internal_order_new_transfer: 'New Transfer',
    host_internal_order_current_sp: 'Current supply center',
    host_internal_order_transfer_to: 'Transfer To',
    host_please_select_consignee: 'Please select consignee',
    host_please_select_telephone: 'Please select telephone',
    host_please_confirm_transfer: 'Confirm Transfer',
    transferToSupplyCenterId: 'Convert supply center',
    skuNum: 'SKU',
    LotNum: 'Lot',
    host_internal_order_current_sp_not_equals_transfer_to_sp:
        'Cannot select the same supply center as the current supply center',
    host_internal_order_current_supply_center_not_null:
        'The current supply center cannot be empty',
    host_internal_order_transfer_to_not_null:
        'Transfer goods to supply center cannot be empty',
    host_internal_order_consignee_not_null: 'Consignee cannot be empty',
    host_internal_order_telephone_not_null: 'Telephone cannot be empty',
    host_internal_order_shipping_address_not_null:
        'Shipping_address cannot be empty',
    host_internal_order_self_pick_up: 'Self pick up',
    host_internal_order_create_number_less_than_current_inventory:
        'The number of new SKUs should be less than or equal to the current library',
    host_internal_order_sku_or_kit_not_null: 'sku or kit should not be empty',
    host_internal_order_sku_not_null: 'sku should not be empty',
    host_internal_order_need_one_sku: 'At least one SKU is required',
    host_internal_order_lot_incorrect: 'is lot incorrect!',
    host_internal_order_stock_shortage:
        'insufficient inventory quantity, please confirm the quantity!',
    host_internal_order_sku_colon: 'SKU:',
    host_internal_order_create_success:
        'Succeeded in create the internal order number',
    host_internal_order_lot_null_or_quantity_less_than_1:
        'Lot is empty or the quantity is less than 1',
    host_internal_order_sku_or_kit_null: 'sku or kit is null',
    host_internal_order_at_least_one_sku: 'At least one SKU is required',
    host_internal_order_lot_not_found: 'Lot is not found',
    host_internal_order_invali_status:
        'Internal order status is invalid and cannot be operated',

    host_message_list: 'Message List',
    host_message_list_admin: 'Administrator: ',
    host_message_list_to_user_name: 'To: ',
    host_message_list_from_user_name: 'From: ',
    host_message_list_task_category: 'Task Category: ',
    host_message_list_task_subcategory: 'Task subCategory: ',
    host_message_list_task_comments: 'Comments: ',
    host_message_list_f1_order_message_list: 'F1 order messages list',

    host_sales_on_hold_message:
        'The order set on-hold, will not trigger replenishment, please contact host if need to ship.',
    host_sales_lock_order_message:
        'The order is in hold status, SC will ship order based on release lock sort, please release lock soon and then allocate inventory.',

    host_sales_on_hold_message1: 'The order set',
    host_sales_on_hold_message2: 'on-hold,',
    host_sales_on_hold_message3:
        'will not trigger replenishment, please set up a shipping plan.',

    host_sales_lock_order_message1: 'The order is in',
    host_sales_lock_order_message2: 'hold status',
    host_sales_lock_order_message3:
        ', SC will ship order based on release lock sort, please release lock soon and then allocate inventory.',

    host_sales_important_note_message: 'Important Note',
    host_sales_important_note_close: 'Close',

    fone_order_details: 'Order Details',
    fone_order_number: 'OrderID: {0}',
    fone_order_eone_number: 'E1 No: {0}',
    fone_order_details_replenishment_date: 'Replenishment Date: {0}',
    fone_order_replenishment_information: 'Replenishment Information',
    fone_order_number_colon: 'OrderID:',
    fone_order_eone_number_colon: 'E1 No:',
    fone_order_eone_status: 'E1 Status：',
    fone_order_receive_date: 'Receive Date:',
    fone_order_replenishment_date: 'Replenishment Date:',
    fone_order_receive_amount: 'Received Qty:',
    fone_order_replenishment_amount: 'Replenishment Qty:',
    fone_order_specifications_colon: 'Unit Size:',
    fone_order_replenishing_colon: 'Replenishment:',
    fone_order_out_of_stock_colon: 'OOS:',
    fone_order_wait_delivery_colon: 'Wait Delivery:',
    fone_order_hold_delivery_colon: 'Hold Delivery:',
    fone_order_current_inventory_colon: 'Actual Qty:',
    fone_order_current_inventory: 'Actual Qty',
    fone_order_replenishing: 'Replenishment',
    fone_order_pre_deliver_time: 'Estimated delivery time',
    fone_order_inventory_detail_cs_email: 'CSforF1@thermofisher.com',
    fone_order_wait_delivery: 'Wait Delivery',
    fone_order_max_inventory_colon: 'Max Qty:',
    fone_order_current_lot: 'Lot：',
    fone_order_ddsna: 'DDSNA: ',
    fone_order_dnsa: 'DNSA: ',
    fone_order_complete_date: 'Validity Date: ',
    fone_order_tobeshipped_quantity: 'Tobeshipped Quantity: ',
    fone_order_stockout_quantity: 'Stockout Quantity: ',
    fone_order_locked_status: 'Locked Status: ',
    fone_order_locked_reason: 'Locked Reason: ',
    fone_order_current_locking_colon: 'Locking Colon',
    fone_order_security_inventory_colon: 'Safety Qty:',
    fone_order_backup_quantity: 'Backup Qty:',
    fone_order_available_stock: 'Available Stock:',
    fone_order_current_actual_colon: 'Actual Colon',
    fone_order_add_to_cart: 'Add',
    fone_order_shopping_cart: 'F1 shopping cart',
    fone_order_enter_comments: 'Please enter your comments',
    fone_order_current_is: 'SC:',
    textarea_max_length:
        'The maximum number of words in remarks shall not exceed 200',
    fone_order_select_all: 'All',
    fone_order_replenishment: 'Replenishment',
    fone_order_confirm_delete: 'Confirm Delete',
    fone_order_confirm_delete_message: 'Are you sure you want to delete it?',
    fone_order_confirm: 'Confirm',
    fone_order_view_inventory: 'View Inventory',
    fone_order_specifications: 'Unit Size',
    fone_order_received_amount: 'Received Qty',
    fone_order_replenished_amount: 'Replenishment Qty',
    fone_order_inventory_details: 'Inventory Details',
    fone_order_total_add_cart: 'Add All',
    fone_order_add_sku: 'Add SKU',
    fone_order_cancel_order: 'End of order',
    fone_order_update_order: 'Update Order',
    fone_order_confirm_cancel_order: 'Confirm to close the order',
    fone_order_confirm_cancel_order_message:
        'Are you sure you want to close the order?',
    fone_order_shippment_details: 'Shippment Details',
    fone_order_storage_condition: 'Storage Condition',
    fone_order_shipping_condition: 'Shipping Condition',
    fone_order_kit_detail: 'Kit Detail',
    fone_order_query_by_sku: 'SKU belong to the blacklist',
    black_list_sku_reason: 'Reasons for blacklist',
    fone_order_out_stock: 'Out Stock',
    fone_order_recent_lot: 'Recent Lot',
    fone_order_selected_lot: 'Selected Lot',
    fone_order_selected_lot_add_success: 'Lot save success',
    fone_order_expiry_date_lot: 'Lot：',
    fone_order_half_year: 'Half Year',
    fone_order_one_year: 'One Year',
    fone_order_same_lot: 'Same Lot',
    fone_black_sku_message: 'sku:{0} is black list',
    fone_order_on_the_parcel: 'On the parcel',
    fone_order_dn_number: 'DN Number',
    fone_order_f1_number: 'F1 Number',
    fone_order_branch_name: 'Branch Name',
    fone_order_replenishment_time: 'Replenishment Time',
    fone_order_delivery_time: 'Delivery Time',
    fone_order_internal_order_number: 'Internal order number',
    fone_order_internal_delivery_warehouse: 'Delivery Warehouse',
    fone_order_internal_order_status: 'Status',
    fone_order_estimated_shipping_time: 'Estimated ship time',
    fone_order_estimated_delivery_time: 'Estimated delivery time',
    fone_order_product_name: 'Product Name',
    product_shippingCondition: 'Shipping Condition',
    product_storeCondition: 'Store Condition',
    shippment_view_all_order_information: 'View All Order Information',
    sub_product_shippingCondition: 'Shipping Condition: ',
    sub_product_storeCondition: 'Store Condition: ',

    shipping_plan: 'Shipping Plan',
    shipping_plan_dialog_submit: 'Submit',
    shipping_plan_dialog_cancel: 'Cancel',
    shipping_plan_dialog_add: 'Add shipping plan',
    shipping_plan_all_quantity: 'All Quantity',
    shipping_plan_shipped_quantity: 'Shipped Quantity',
    shipping_plan_quantity: 'Quantity',
    shipping_plan_date: 'Date',
    shipping_plan_remark: 'Remark',
    shipping_plan_add_success: 'Shipping Plan Added Successfully',
    shipping_plan_needed_one_plan: 'At least one shipment plan is required.',
    shipping_plan_quantity_cannot_exceed_total_quantity_SKUs:
        'The quantity of the shipment plan cannot exceed the total quantity of SKUs.',
    shipping_plan_added_plan_cannot_delete:
        'The shipping plans that have been added cannot be deleted.',
    shipping_plan_quantity_not_new_plan:
        'There are currently no newly added shipment plans.',
    shipping_plan_shipped_quantity_not_null:
        'The planned shipment quantity cannot be empty.',
    shipping_plan_shipped_date_not_null:
        'The planned shipment date cannot be empty.',
    shipping_plan_today_plan: 'Today Plan',
    shipping_plan_shipping: 'ship',
    shipping_plan_shipping_unit: ' one',

    proxy_delivery_package_detail_not_found: 'Package Details Not Found',
    proxy_delivery_package_detail_not_found_message:
        'Sorry, we are unable to find the package details at the moment',
    proxy_delivery_customer_receive_not_started:
        'Customer delivery has not started yet',
    notification_customer_successful_receipt_of_goods:
        'Customer successfully received goods',
    proxy_delivery_package_host_receive_confirm_text:
        'Please confirm whether the order address is within the delivery range. If it is, please ensure the receipt includes a signature and date.',
    proxy_delivery_package_customer_receive_confirm_text:
        'If the customer receives the goods in person, please ensure the receipt includes a signature and date; if the customer signs on behalf, please ensure the receipt includes a signature, date, and phone number.',
    proxy_delivery_go_on_receive: 'Receive Again',

    shipping_plan_complete: 'Complete',
    shipping_plan_complete_confirm_message: '是否确认完成该发货计划？',
    shipping_plan_complete_suffix: '?',
    sales_shipping_plan_sync_reminder:
        'Please add a shipping plan to match the delivery requirement.',
    common_operation: 'Operation',

    header_fone_order: 'F1 Order',
    header_select_customer: 'Select Customer',
    header_delivery_management: 'Delivery Management',
    header_fone_shippment_management: 'F1 Receiving Management',
    header_abnormal_reagent_record: 'Abnormal Reagent Records',
    header_fone_refresh: 'Synchronous',

    black_user_not_settle: 'You have an overdue account',
    black_user_contact_service:
        'Order cannot be placed temporarily, please contact sales',
    black_user_not_activate:
        'The current user is not activated, please contact customer service.',

    supplycenterchina_email: 'supplycenterchina@thermofisher.com',
    welcome_demosite: 'Dear customer, welcome to thermofisher supply center.',
    return_tfs_website:
        'At present, there is no supply center around you to provide services, the current browsing is supply center experience station, if you need to return',
    thermofisher_link: 'Samphire on the palm',
    please_click_link: '，please click',
    enjoy_ultimate_experience_one_stop_service:
        'Enjoy the ultimate experience of one-stop service.',
    mapac_thermofisher_email: 'mapac.thermofisher.cn',
    anyway_problem_please_call: 'If you have any questions, please contact',

    user_center: 'User Center',
    user_center_placeorder_for_customer: 'Placeorder For Customer',
    user_center_create_order: 'Create Order',
    user_center_view_all_order: 'View All Orders',
    user_center_not_receive: 'Not Receive',
    user_center_received: 'Received',
    user_center_canceled: 'Cancelled',
    user_center_fone_order: 'F1 Order',
    user_center_replenishment_management: 'Replenishment Management',
    user_center_delivery_management: 'Delivery Management',
    user_center_fone_receive_management: 'F1 Receive Management',
    user_center_abnormal_reagent: 'Abnormal Reagent',
    user_center_inventory_query: 'Inventory Query',
    user_center_inventory_details: 'Inventory Details',
    user_center_view_inventory: 'View Inventory',
    user_center_order_report: 'Order Report',
    user_center_account_sync: 'Account Sync',
    user_center_account_sync_ST: 'Ship To Sync',
    user_center_account_sync_online: 'Web Account Sync',
    user_center_enter_sync_ST: 'Please enter the ST',
    user_center_enter_sync_online: 'Please enter login name',
    user_center_sync_login_name: 'Login Name',
    user_center_sync: 'Sync',
    user_center_sync_no_content: 'Account was not found',
    user_center_sync_success: 'Synchronization Success',
    user_center_sync_failed: 'Synchronization Failed',
    user_center_test_warning_flag: 'Warning: This is a test environment',

    user_center_proxy_delivery_order_management:
        'Proxy Delivery Order Management',

    proxy_delivery_received_awaiting_status: 'Received Pending',

    proxy_delivery_order_management_order_number: 'E1 Number',
    proxy_delivery_order_list_create_time: 'Order Time',
    proxy_delivery_order_list_search_placeholder:
        'Enter DN Number/E1 Number/SKU',
    proxy_delivery_order_list_orderNo_EoneNo:
        'Enter SKU/Order Number/E1 Number',
    proxy_delivery_order_list_order_status: 'Order Status',
    proxy_delivery_order_list_order_quantity: 'Order Quantity:',
    proxy_delivery_order_list_estimated_delivery_time:
        'Estimated Delivery Time',
    proxy_delivery_package_upload_photo:
        'Click here to take a photo and upload the package image',
    proxy_delivery_customer_receive: 'Customer Receive',
    proxy_delivery_package_detail_not_exist: 'Package details not found.',
    proxy_delivery_package_upload_file_bad_file_format:
        'The uploaded image format is incorrect. Allowed file formats are: [jpg, jpeg, png]',
    proxy_delivery_signReceipt: 'Sign Receipt',
    proxy_delivery_signReceipt_preview: 'Preview',
    proxy_delivery_sign_info: 'Sign Info',
    proxy_delivery_signReceipt_time: 'Sign Time',
    proxy_delivery_signReceipt_Host: '(Host)',
    proxy_delivery_signReceipt_Customer: '(Customer)',
    proxy_delivery_reject_reason: 'Reject Reasons',
    proxy_delivery_reject: 'Reject',
    proxy_delivery_reject_package: 'Reject Package',
    proxy_delivery_reject_remark: 'Reject Remark',
    proxy_delivery_reject_remark_required: 'Reject remark is required',
    proxy_delivery_reject_reason_required: 'Reject reason is required',
    proxy_delivery_confirm_reject: 'Confirm Reject',
    proxy_delivery_reject_success: 'Reject Success',
    proxy_delivery_customer_reject_success: 'Customer Reject Success',
    proxy_delivery_host_once_again_receive_success:
        'Receive Success! Please check the package in the received pending list',
    proxy_delivery_customer_once_again_receive_success:
        'Receive Success! Package delivery is complete',
    proxy_delivery_customer_reject: 'Customer Reject',
    proxy_delivery_delivery: 'Delivery',
    proxy_delivery_reason: 'Reason: ',
    proxy_delivery_remark: 'Remark: ',
    proxy_delivery_reject_type_incorrect:
        'Reject type is incorrect, please confirm here',
    proxy_delivery_package_complete_not_reject:
        'The package has been signed and cannot be rejected',
    proxy_delivery_package_not_allowed_reject:
        'The current package status does not allow rejection',
    proxy_delivery_package_status_not_allowed_to_receive:
        'The current package status has changed and cannot be signed',
    proxy_delivery_package_SHIPMENT_NOT_EXIST: 'Shipment does not exist',
    proxy_delivery_reject_label: 'Rejected',
    proxy_delivery_shipto_remark: 'Sign Require',
    proxy_delivery_shipment_status: 'Shipment Status',
    proxy_delivery_order_quantity: 'Order Quantity',

    user_center_task_management: 'Task Mmanagement',
    user_center_task_management_search_placeholder: 'Order Number/E1 No/SKU',
    user_center_task_management_tobe_completed: 'To be completed',
    user_center_task_management_in_follow_up: 'In follow up',
    user_center_task_management_all_completed: 'in_follow_up',
    task_management_score: 'score',
    task_management_mandatory: 'Mandatory',
    task_management_non_mandatory: 'Non Mandatory',
    task_management_mandatory_task: 'Mandatory task × {0}',
    task_management_non_mandatory_task: 'Non mandatory task × {0}',
    task_management_key_point: 'Key Point',
    task_management_latest: 'Latest',
    task_details: 'Task Details',
    task_details_contact: 'contact',
    task_details_please_input_contact: 'Please input contact',
    task_details_phone: 'Phone',
    task_details_please_input_phone: 'Please input phone',
    task_details_position: 'Position',
    task_details_please_input_position: 'Please input position',
    task_details_submit: 'submitted',
    task_details_go_back_order: 'Go back order',
    task_details_upload_image: 'Upload image',
    task_details_confirm_upload_image: 'Confirm upload image',
    task_details_upload_here: 'Click here to upload an image',
    task_details_assignment_customer: 'Assignment Customer',
    task_details_task_search_placeholder: 'Task no/task name/shipTo/alpha name',
    task_details_assignment_customer_search_placeholder: 'ShipTo/alpha name',
    task_details_please_complete: 'Please complete it before {0}',
    task_details_please_non_mandatory_complete_date: 'Expires date {0}',
    task_details_task_name: 'Task Name',
    task_management_progress_task_label: 'Keep following up',
    task_management_progress_task: 'Keep following up × {0}',
    task_management_submitted_task: 'Submitted × {0}',

    task_details_view_task: 'View',
    task_details_multiple: '（Multiple）',
    task_details_single: '（Single）',
    task_details_gap_filling: '（Gap Filling）',
    task_details_query_customer: 'Find Customer',
    task_details_select_customer: 'Select Customer',
    searchStQueryKey: 'Select Customer',
    task_details_closeness: 'Closeness',
    task_details_submit_success: 'Submit Success',
    task_details_input_select_customer: 'Input and select a customer',
    task_details_select_contacts: 'Select Contacts',
    task_details_please_select_contacts: 'Select Contacts',
    task_details_required_not_do:
        'You have required questions that are not filled in. Please review carefully.',
    task_details_input_content_max_100:
        'The maximum input length is 100 characters.',
    task_details_contact_max_30:
        'The maximum length for the contact name is 30 characters.',
    task_details_position_max_20:
        'The maximum length for the position is 30 characters.',
    task_details_task_info: 'Supplementary Information',
    task_details_tracking_status: 'Tracking Status',
    task_details_tracking_desc: 'Task Desc',
    task_details_message_desc: 'Reply',
    task_details_replay_message: 'Replay Message',
    task_details_messge_send_success: 'Messge send success',
    task_details_submit: 'Submit',
    task_details_p_submit: 'Submited',
    task_progress_task_comments_not_null: 'Reply cannot empty',
    task_details_number: 'Task Number',
    task_details_subject: 'Subject',

    user_center_account_confirm_frozen: 'Confirm Lock',
    user_center_account_confirm_unfrozen: 'Confirm Unlock',
    user_center_account_frozen: 'Lock',
    user_center_account_unfrozen: 'Unlock',
    user_center_account_enter_frozen_st:
        'Please enter the BT you want lock individually',
    user_center_account_enter_unfrozen_st:
        'Please enter the BT you want unlock individually',
    task_details_not_customer_please_select_customer:
        'Customer cannot be empty, please select a customer.',
    task_details_please_select_closeness: 'Please select a closeness',
    task_details_please_dropdown_select_customer:
        'Please select the corresponding customer from the dropdown menu.',
    task_details_illegal_customer: 'Illegal Customer',

    user_center_contact_us: 'Contact Us',
    user_center_contact_amanda: 'AMandA',
    user_center_logout: 'Log Out',
    user_center_logout_message: 'Are you sure you want to log out?',
    user_center_delivery_colon: 'Distribution:',
    user_center_order_choose_time: 'Select Order Time',
    user_center_period: 'To',
    user_center_report_send_to: 'The order report will be sent to',
    user_center_confirm_send: 'Send',
    user_center_account_information: 'My account information',
    user_center_default: 'Default',
    user_center_set_default: 'Set',
    user_center_application_backup: 'Apply for the backup',

    backup_status_INIT: 'INIT',
    backup_status_APPROVED: 'Approved',
    backup_status_REVOKE: 'Approved',
    backup_status_DECLINE: 'Approved',
    backup_status_RECALL: 'Cancelled',
    backup_delivery_date: 'Delivery Date',
    backup_sc_not_cover_user_city:
        'The supply center you manage does not cover the user city',
    backup_plan_order_date: 'Planned Order Time',
    backup_delivery_date_placeholder: 'Please enter the delivery time',
    backup_sku: 'SKU',
    backup_sku_placeholder: 'Please enter the SKU you want to back up',
    backup_login_email: 'Login Email',
    backup_login_account: 'Account',
    backup_lab_or_dept: 'Dept',
    backup_lab_or_dept_placeholder: 'Please enter the dept',
    backup_supply_center: 'Supply Center',
    backup_supply_center_placeholder: 'Please select the SC',
    backup_ship_to_placeholder: 'Please select the Ship To',
    backup_quantity: 'Backup Qty',
    backup_apply: 'Apply',
    backup_comments: 'Remark',
    backup_comments_placeholder: 'Please enter remarks',
    backup_institution: 'Unit',
    backup_institution_placeholder: 'Please enter the unit',
    backup_list_title: 'Application list',
    apply_backup_title: 'Apply Backup',
    apply_backup_submit: 'Apply',
    backup_please_input_sku: 'Please input sku',
    backup_please_input_lot: 'Please input sku',
    backup_inventory: 'Inventory',
    backup_inventory_quantity: 'Inventory Quantity',
    backup_application_quantity: 'Application Quantity',
    backup_application_reason: 'Backup Reason',
    backup_application_other_reason: 'Remark',
    backup_application_other_reason_not_null:
        'When the backup reason is other, the remark field cannot be left blank. ',
    backup_application_other_reason_not_more_than_100:
        'The length of the remark cannot exceed 100 characters',
    backup_application_reason_placeholder: 'Please select backup reason',
    backup_please_input_other_reason: 'Please input remark',
    backup_stockup_quantity: 'The stocking status: current stock quantity{0}',
    backup_your_application_quantity: '(Your application{0})',
    backup_confirm_stock_up: 'Please confirm stock application form',
    backup_confirm_submit: 'Submit',
    backup_confirm_cancel: 'Cancel',
    backup_line: '--',
    backup_onroad_quantity: 'On road quantity',
    backup_delete_button: 'Delete',
    backup_add_sku_button: 'Add SKU',
    backup_need_one_sku: 'At least one SKU is required for backup application',
    backup_not_application: ' not application backup,',
    backup_due_to: ' due to ',
    backup_revoke: 'Revoke',
    backup_application_date: 'Application Time',
    backup_revoke_successs: 'Revoke Successs',
    backup_revoke_failure: 'Revoke Failure',
    backup_revoke_backup: 'Revoke Backup',
    backup_confirm_revoke_backup: 'Are you sure you want to revoke the backup?',
    backup_revoke_backup_confirm: 'Confirm',
    backup_host_sales_apply_goods:
        'I am aware thatt this stocked product serves the customer needs that have been confirmed within 7 days, and the corresponding batch may not necessarily be allocated to my order. The stock center will ship according to the order of the unlocked orders.',
    backup_apply_banner_info:
        'If your order date is more than seven days away, please refrain from applying for stock preparation temporarily.',

    product_management_small_to_big: 'Small to big',
    product_management_big_to_small: 'Big to small',
    product_management_specification_conversion: 'Specification Conversion',
    product_management_conversion_specification: 'Conversion Specification',
    product_management_product_converted: 'The product will be converted into',
    product_management_conversion_confirm: 'Confirm',
    product_management_scilicet: 'scilicet (',
    product_management_unit: ') 单位',
    product_management_big_size: 'big',
    product_management_small_size: 'small',
    product_management_sku: 'SKU：',
    product_management_nubmer_colon: 'nubmer：',
    product_management_nubmer: 'Number',
    product_management_conversion_success: 'Conversion Success',
    notification_please_select_the_batch_deletion_item: 'Batch Deletion',
    product_management_convert_sku_out_stock:
        'Conversion quantity is more than current inventory, conversion failed',
    product_management_sku_not_exist:
        'Source sku is not in current supply center, update failed',
    product_management_convert_target_sku_not_exist:
        'target sku is not in current supply center, update failed',
    product_management_convert_target_sku_number_error:
        'Incorrect number of target sku, update failed',
    product_management_convert_target_sku_exist_multiple_components:
        'There are multiple components in the target sku and cannot be converted',
    product_management_convert_target_sku_source_not_convert:
        'source sku cannot be converted',

    b2b_management_config: 'B2B配置',
    b2b_management_please_select_shipto: 'Please enter shipTo',
    b2b_management_query_subject: 'Please query subject',
    b2b_management_platform: 'Platform',
    b2b_management_please_select_platform: 'Please select platform',
    platformShipto: 'Platform ShipTo',
    b2b_management_please_select_platform_shipto:
        'Please select platform shipTo',
    b2b_management_use_wop: 'User WOP',
    b2b_management_use: 'Usage',
    b2b_management_not_use: 'Nonuse',
    b2b_management_whether_split_order: 'Whether split order',
    b2b_management_split_order_methods: 'Split order forms',
    b2b_management_supply_center_inventory_split_order:
        'SP inventory split order',
    b2b_management_customer_PO_number_split_order: 'Customer po number',
    b2b_management_contact_email: 'Contact Email',
    b2b_management_description: 'Description',
    b2b_management_submit: 'Submit',
    b2b_management_update: 'Edit',
    b2b_management_shipto_not_null: 'ShipTo is not null',
    b2b_management_subject_not_null: 'Subject is not null',
    b2b_management_supply_center_not_null: 'Supply center is not null',
    b2b_management_platform_not_null: 'Platform is not null',
    b2b_management_save_success: 'Save Success',
    b2b_management_platform_shipto_duplicate: 'Platform ship to duplicate',
    b2b_management_platform_shipto_invalid: 'Invalid ship To',
    b2b_management_add: 'Add',
    b2b_management_platform_list: 'B2B platform list',
    b2b_management_platform_list_wop: 'WOP',
    b2b_management_platform_list_shipTo: 'Ship To',
    b2b_management_query_subject: 'Query Subject',
    b2b_management_enter_st_or_subject: 'enter ST/Subject',
    b2b_management_not_found_st_bind: 'Not found st bind relation',
    b2b_management_input_add_email: 'Please enter your email and click Add',
    b2b_management_input_description: 'Please enter your input description',
    b2b_management_please_select_account: 'Please select account',
    b2b_management_platform_shipto_not_null:
        'The platform ShipTo cannot be empty',

    st_management: 'ST管理',
    st_management_subject: 'Subject',
    st_management_st_address: 'ST Address',
    st_management_current_sp: 'Current supply center',
    st_management_transation_method: 'Transation Method',
    st_management_application_changing: 'Apply Changing',
    st_management_apply_change: 'Apply Change',
    st_management_not_repeat_apply_change:
        'You have applied for a change in the relation of the ST to the supply center！',
    st_management_confirm_apply: 'Confirm Apply',
    st_management_apply_reason: 'Apply Reason',
    st_management_apply_sp: 'Apply supply center',
    st_management_please_select_apply_sp: 'Please select apply supply center',
    st_management_shipto_address: 'ShipTo Address',
    st_management_apply_sp_is_not_null: 'Apply supply center is not null.',
    st_management_apply_reason_is_not_null: 'Apply reason is not null',
    st_management_apply_reason_length_not_more_than_200:
        'Apply reason is not more than 200',
    st_management_transation_method_is_not_null:
        'Transation method is not null',
    st_management_apply_change_success: 'Apply change success',
    st_management_no: 'No',
    st_management_please_enter_apply_reason: 'Please enter apply reason',
    shippment_customer_feedback_submit: 'Submit',
    shippment_customer_feedback_cancel: 'Cancel',
    shippment_please_input_customer_feedback:
        'Please enter consignee role, customer recommendation sheet content preferences, customer opportunities, product usage questions...',
    shippment_customer_feedback_content_is_not_null:
        'Customer feedback content cannot be empty',
    shippment_feedback_history: 'Feedback History',
    st_management_have_received_apply: 'We have received apply',
    st_management_associated_sp: 'Associated supply center',
    st_management_associated_sp_yes: 'Yes',
    st_management_associated_sp_no: 'No',

    mobile_label: 'Mobile',
    phone_label: 'TEL',
    i_got: ' I get it',
    input_required: 'This item is required',
    withdraw: 'Logout',
    loading: 'Loading...',
    shipment_list_load_failed: 'Failed to load order list',
    shipment_list_reload: 'Reload',
    already_in_the_bottom: 'The End',
    record_number: 'ICP: Shanghai ICP 11003924',
    business_license: 'Business licenses',
    search: 'Search',
    enter_sku_orderNo: 'Enter the SKU/OrderID',
    enter_sku_orderNo_EoneNo: 'Enter the SKU/OrderID/SKU/E1 No',
    enter_onload_package_search_criteria: 'Enter DN No/F1 No/Order No/SKU',
    search_history: 'Search History',
    enter_express_number: 'Please enter the express number',
    confirm_delivery_order:
        'Please confirm whether the invoice shows the price:',
    delivery_order_label: 'whether the invoice shows the price:',
    show_eone_set_price: 'The price of this ST in E1 is set to',
    eone_set_show_price: 'Show Price',
    eone_set_not_show_price: 'Hide Price',
    display: 'Show',
    not_display: 'Hide',
    confirm_delivery: 'Confirm Delivery',
    enter_orderNo_eoneNo_sku_subject_receiver_po:
        'OrderID/E1 No/SKU/Dept/Consignee/PO',
    login: 'Login',
    password_not_valid: 'Your password is wrong, please enter it again',
    enter_mobile: 'Enter user name',
    enter_password: 'Enter password',
    userName: 'User Name',
    password: 'Password',
    enter_purchase_number: 'Please enter the purchase order number',
    enter_note: 'Please enter remarks',

    enter_scNo_scName_orderNo: 'Enter SC No/SC Name/OrderID',
    enter_scNo_scName_orderNo_EoneNo: 'Enter SC No/SC Name/OrderID/E1 No',
    enter_sku: 'Enter SKU',
    enter_sku_and_name: 'Enter sku or name',
    enter_sku_need_add: 'Please enter the SKU you want to add',
    enter_orderNo_sku_subject_eoneNo: 'Enter OrderID/SKU/Dept/E1 No',
    exit: 'Logout',
    enter_sku_and_product_name: 'Enter sku or product name',

    enter_email_receive_report:
        'Please enter the mailbox to receive the order report',
    enter_orderNo_eoneNo: 'OrderID/E1 No',
    enter_order_purchase_number: 'Purchase Order No',
    ST: 'ST',
    enter_user_account: 'User Account',
    enter_order_status: 'Order Status',
    enter_advanced_order_type: 'Order Type',
    'query-order-more-options': 'More Options',
    invalid_token: 'Invalid Token',
    invalid_userRole: 'Invalid User Role',
    no_supply_center: 'No supply center',
    role_incorrect: 'The user role is incorrect',

    clause_content_one:
        'You agree to the terms and conditions of sale of thermofishers.cn for the products you purchase.',
    clause_content_two: 'Click to view the terms and conditions of sale.',
    clause_content_three:
        'All products sold on this website shall not be used for clinical diagnosis or treatment of humans or animals, only for non-medical purposes such as industrial or scientific research.',

    feedback_write_here: 'Please write down your feedback here',
    feedback_confirm: 'Feedback',
    copy: 'Copy',
    company_stock: 'Company Stock',
    warehouse: 'Warehouse:',
    available_quantity: 'Effective quantity:',
    ddnsaDate: 'DDNSA Date:',
    dnsaDate: 'DNSA Date:',
    get_inventory_details_error1: 'This SKU company inventory was not obtained',
    is_not_delivery: 'Will the goods not be delivered now',
    yes: 'Yes',
    no: 'No',
    promotion_code: 'P/D Quote:',
    in_stock: 'In Stock',
    stockout: 'Stockout',
    short_of_stock: 'Shortage',
    to_send_the_goods: 'Wait Send',
    wait_for_receiving: 'Wait',
    have_been_signed: 'Signed',
    off_the_stocks: 'Done',
    pending_orders: 'Pending Orders',
    Shipped_order: 'Shipped Order',
    part_of_the_shipment: 'Partial Shipments',
    Part_of_sign_after_receiving_STH: 'Partial Signed',
    all_shipments: 'All Shipments',
    no_delivery_order: 'No Delivery Order',
    signed_for_order: 'Signed Order',
    cancelled_order: 'Cancelled Order',
    partial_cancelled_order: 'Partial Cancelled Order',
    received_order: 'Received Order',
    supply_center_goods: 'SC Product',
    advance_payment: 'Prepaid',
    TFS_goods: 'TFS Products',
    promotional_code: 'Please enter promo code',
    discount_code: 'promo code',
    TFS_supply_center_experience_the_site: 'TFS SC Experience The Site',
    set_language: 'Set Language',
    system_notification: 'Notification',

    b2b_management: 'B2B Management',
    internal_transfer_order: 'Internal transfer order',
    internal_transfer_order_detail: 'Internal transfer order detail',
    internal_transfer_order_shippingCondition: 'Shipping Condition',
    internal_transfer_order_storeCondition: 'Store Condition',
    internal_transfer_order_specifications: 'Specifi Cations',
    chinese: '中文简体',
    english: 'English',
    hot_recommended: 'Popular recommended',
    hot_recommended_cart: 'Recommended for you',
    hot_recommended_order: 'More to Love',
    learn_more: 'Learn More>',
    financial_status: 'Financial-',
    order_status: 'Order-',
    express_type: 'Express-',
    all_order: 'All Order',
    no_lock: 'No Lock',
    locked: 'Locked',
    order_in_stock: 'In Stock',
    no_stock: 'No Stock',
    direct_method: 'Direct Method',
    mail_method: 'Mail Method',
    CannotBelessThan3Words: 'Cannot be less than 3 words',
    shipment_sales: 'Sales Create',
    shipment_customer: 'Customer Create',

    notification_successful_receipt_of_goods: 'Received successfully',
    notification_successful_delivery: 'Successful delivery',
    notification_add_a_success: 'Add successfully',
    notification_picture_upload_failed: 'Upload Fail',
    notification_update_proof_success: 'Update proof successfully',
    notification_upload_at_least_one_proof:
        'Please upload at least one proof image',
    notification_all_goods_received_successfully:
        'All goods received successfully',
    notification_the_batch_number_shall_not_exceed_15:
        'The batch number shall not exceed 15',
    notification_order_cannot_be_operated:
        'This order cannot be operated, please contact the administrator',
    notification_successfully_cancel_the_order: 'Successfully cancel the order',
    notification_cancellation_request_has_been_sent:
        'Your request for cancellation has been sent. If you have questions, please contact supplycenterchina@thermofisher.com',
    notification_order_cancellation_failed: 'Order cancellation failed',
    notification_please_select_picture: 'Please select picture',
    notification_please_select_package: 'Please select package',
    po_number_empty: 'PO number is empty for the order.',
    notification_cancel_reason_not_exceed_90: 'Cancel reason not exceed 90',
    order_has_confirmed:
        'The customer has confirmed, and the order cannot be cancelled.',

    notification_already_temporarily_does_not_deliver_goods:
        'Deley the order successfully,Please view the order at delay delivery list',
    package_withdrawn_successfully: 'Package withdrawn successfully',
    grey_list_products_can_not_be_temporarily_shipped:
        'Grey list products, can not be temporarily shipped',
    failed_to_withdraw_package: 'Failed to withdraw package',
    withdrawal_of_package: 'Withdrawal Package',
    confirm_cancellation_of_package: 'Confirm cancellation of package?',
    cancellation_of_package_message1:
        'After canceling the package, please contact the sales representative to manually cancel the shipping status on Kasama Mall. Once it is successfully canceled, you can proceed with the delivery again.',
    cancellation_of_package_message2: 'Thermo Fisher order number{0}',
    cancellation_of_package_message2: 'PO number{0}',
    cancellation_of_package_message3: 'SKU{0}: {1}',
    cancellation_of_package_message4: 'Quantity: {0}',
    cancellation_of_package_copy: 'Copy All',

    notification_successfully_upload: 'Upload Successfully',
    notification_confirmed_the_customer_receipt:
        'Upload successfully! You have successfully confirmed the customer receipt!',
    notification_already: 'Already',
    notification_go_to: ',Go to ',
    notification_then: 'Then ',
    notification_jump_to: ' Jump to ',
    notification_view_order_details: 'View order details',
    notification_go_to_admin_view_f1_details:
        'Go to admin management view f1 details',
    notification_page: ' page',
    notification_list_to_view: 'List View',
    notification_purchase_order_no_more_than_25_digits:
        'Purchase order number cannot exceed 25 digits',
    notification_note_message_is_too_long: 'Note message is too long',
    notification_please_check_and_confirm_the_terms:
        'Please check and confirm the terms',
    notification_expected_delivery_date_is_less_than_the_current_date:
        'The expected delivery date is earlier than the current date',
    notification_order_generation_failed: 'Order generation failed',
    notification_order_promo_invalid:
        'Invalid quote. Please check if your quote is used correctly and try again',
    notification_order_promo_expired:
        'Promo code expired, please contact admin',
    notification_order_promo_not_active_or_expired:
        'The quote you entered has expired or is not yet active',
    notification_order_promo_mismatch:
        'Quote is not applicable to this order, please check if your quote is used correctly',
    notification_order_promo_failed:
        'Quote application failure, please contact the administrator',
    notification_invalid_st_or_bt:
        'The current customer ST/BT is abnormal or invalid and cannot submit the order, please contact AMT or CSR team to follow up the account issue',
    notification_invalid_combination_quote:
        'Sorry, The maximum number of promo codes used for this order has been reached. You can divide your order and use the promo code separately.',
    notification_not_repeat_p_quote: 'Only one P coupon can be used for orders',
    notification_not_repeat_d_quote: 'Only one D coupon can be used for orders',
    notification_not_repeat_r_quote: 'Only one R coupon can be used for orders',
    notification_not_repeat_m_quote: 'Only one M coupon can be used for orders',
    notification_promotion_code_applied_successfully:
        'Quote applied successful',
    notification_promotion_code_final_price_is_best:
        'Quote applied successful. The final price is currently considered as low',
    notification_promotion_quote_exist:
        'The quote already exists and has been applied successfully',
    notification_please_select_the_replenishment_item:
        'Please select the replenishment item',
    notification_invalid_cartId: 'Invalid Cart id',
    notification_item_quantity_cannot_be_0: 'Item quantity cannot be 0',
    notification_feedback_submitted_successfully:
        'Feedback submitted successfully',
    notification_copy_success: 'Copy successfully',
    notification_purchase_start_time_shall_not_be_greater_than_the_end_time:
        'The purchase start time shall not be greater than the end time',
    notification_order_start_time_shall_not_be_greater_than_the_end_time:
        'The start time of the order shall not be greater than the end time',
    notification_order_report_has_been_sent_to_the_mailbox:
        'The order report has been sent to the mailbox',
    notification_arrival_time_is_less_than_the_current_date:
        'The arrival time is earlier than the current date',
    notification_successfully_applied_for_sku_listing:
        'Successfully applied for sku listing',
    notification_we_have_received_your_application:
        'We have received your application',
    notification_successfully_set: 'SET OK',
    notification_others_have_been_cancelled:
        ' parcel, the others have been cancelled',
    notification_system_crashed:
        'System crashed. Customer service has been notified',
    notification_network_unstable: 'The network is unstable, please try later',
    notification_page_error: 'Page error. Customer service has been notified',
    notification_unauthentication: 'Failed user authentication',
    notification_not_permission: 'The user does not have this permission',
    notification_order_submission_failed: 'Order submission failed',
    notification_invalid_sku: 'Invalid SKU',
    notification_invalid_sku_price: 'SKU: {0} No price, not allowed to sell',
    notification_invalid_phone: 'Invalid phone',
    notification_password_error: 'Wrong Password',
    notification_refresh_page: 'Please refresh the page and try again',
    notification_goods_failed: 'The goods failed',
    notification_receive_code_mismatch:
        'Receiving code mismatch, receiving failed',
    notification_delivery_failed: 'The delay in delivery has failed',
    notification_delivery_failure: 'The delivery failure',
    notification_no_delivery_order: 'No delivery is allowed on this order',
    notification_no_delay_shipment_order:
        'No delay in shipment is allowed under this order',
    notification_gray_list_info:
        'This product is grey list product, please ensure that this product is replenished to the spot center immediately shipped',
    notification_no_shipment_order: 'Shipment is not allowed under this order',
    notification_order_not_cancelled: 'This order cannot be cancelled',
    notification_order_not_found: 'This order could not be found',
    notification_change_failed: 'Change failed',
    notification_delivery_quantity_error: 'Delivery quantity error',
    notification_replenishment_quantity_error:
        'The replenishment quantity is wrong',
    notification_product_sent_wrong: 'The product sent is wrong',
    notification_order_cannot_be_partially_cancelled:
        'This order cannot be partially cancelled',
    notification_product_repeatedly: 'Product repeatedly',
    notification_addition_failed: 'Addition failed',
    notification_no_sc:
        'You do not belong to the supply center, please contact the administrator',
    notification_the_number_of_exceptions_exceeds_the_actual_inventory:
        'The number of exceptions exceeds the actual inventory',
    notification_the_quantity_shipped_exceeds_the_actual_stock:
        'The quantity shipped exceeds the actual stock',
    scrapped_quantity_is_not_greater_than_actually_inventory:
        'to be scrapped quantity is not greater than actually inventory',
    notification_sku_not_exist: 'The article number does not exist',
    notification_sku_not_valid:
        'The item number is not valid in the supply center',
    notification_file_upload_failed: 'File upload failed',
    notification_login_again: 'Please login again',
    notification_tel: 'TEL 4008208982',
    notification_failed_to_buy_again: 'Failed to buy again',
    notification_no_order_report_is_available: 'No order report is available',
    notification_no_sku: "SKU doesn't exist",
    notification_yes_sku: 'SKU exists',
    notification_user_details_were_not_obtained:
        'User details were not obtained',
    notification_setup_failed: 'Setup failed',
    notification_order_report_delivery_failed: 'Order report delivery failed',
    notification_no_deliveryman_information_was_obtained:
        'No deliveryman information',
    notification_order_locked:
        'The order cannot be shipped at present due to the overdue settlement of your account or the financial situation of exceeding the credit limit.You can contact our sales department at any time for financial information and invoice processing.',
    notification_host_order_locked:
        "The order cannot be shipped at present due to the overdue settlement of this user's account or the financial situation of exceeding the credit limit.You can contact our sales department at any time for financial information and invoice processing.",
    notification_order_c1_and_c2_locked:
        'The order cannot be shipped at present due to the overdue settlement or the financial situation of exceeding the credit limit. It will be shipped after the credit control team reviews and unlocks it.',
    notification_order_ed_locked:
        'The order has a note, it will be shipped after the ED release team reviews and unlocks it.',
    notification_order_other_locked:
        'The order is under review, it will be shipped after the system reviews and unlocks it.',
    notification_quote_null: 'SKU quote was not retrieved',
    notification_get_quote_failed: 'Query quote failed',
    notification_invalid_lock:
        'This order is subject to financial audit or locked and cannot be shipped',
    pleaseSelectTransferto: 'Please select transfer to',
    transfer: 'Transfer',
    stockTransform: 'Stock Transform',
    include: 'Include',
    includeProduct: 'Include Product',
    submitSuccess: 'Submit Success',
    submitFail: 'Submit Fail',
    withdrawSuccess: 'Withdraw Success',
    ReceiveSuccess: 'Receive Success',
    ReceiveFail: 'Receive Fail',
    withdrawFail: 'Withdraw Fail',
    transferPackage: 'Transfer Package',
    cancelPackage: 'Cancel Package',
    confirmPackage: 'Confirm Cancel Package',
    confirmTransferPackage: 'Confirm Transfer Package?',
    nolotData: 'No lot Data',
    transferNumber: 'Transfer Number',
    supplyCenterId: 'Name',
    to_be_scrapped_quantity:
        'to be scrapped quantity is not greater than actually inventory',
    copyall_btn_label: '一键复制',
    receive_repeat_tip: '收货请求已提交，请勿重复操作',
    apply_for_listing: 'apply for listing',
    apply_for_listing_product: 'apply for listing product',
    sku_is_in_black_list: 'SKU is in black list',
    sku_is_invalid_sku: 'SKU is invalid SKU',
    sku_is_exist_in_current_SC: 'SKU is exist in current SC',
    sku_no_have_list_price: "SKU doesn't have list price",
    submit_sku_is_in_black_list: 'SKU is in black list',
    submit_sku_is_invalid_sku: 'SKU is invalid SKU',
    submit_sku_is_exist_in_current_SC: 'SKU is exist in current SC',
    submit_sku_no_have_list_price: "SKU doesn't have list price",
    confirm_sku_info: 'Confirm Sku Info',
    internal_order_expressway_self: 'self',
    internal_order_expressway_express: 'express',
    internal_order_expressway_: '',
    btn_action_ok: 'OK',
    btn_action_cancel: 'Cancel',
    your_message_list: 'Your Message List',
    transferSuccess: 'Transfer Success number',
    transferFail: 'Transfer Fail',
    your_message_sign_read: 'mark as read',
    your_message_read: 'read',
    your_message_unread: 'un read',
    your_message_marked_read: 'marked as read',
    your_message_admin_message: 'Administrator Message',
    your_message_order_message: 'Order Message',
    your_message_task_message: 'Task Message',
    your_message_system_message: 'System Message',

    transport: 'Transport',
    storage: 'Storage',
    your_message_qty: 'Qty',
    all_apply: 'All Apply',
    all_apply_applicant: 'Applicant',
    all_apply_role: 'Role',
    all_apply_apply_sc: 'Apply supplyCenter',
    all_apply_apply_time: 'Apply Time',
    all_apply_look_self: 'Just look at yourself',
    all_apply_approval_details: 'Approval Details',
    all_apply_approver: 'Approver',
    all_apply_approval_time: 'Approval Time',
    all_apply_actual_supply_center: 'Actual Supply Center',
    all_apply_actual_distribution_mode: 'Actual Distribution Mode',
    all_apply_approval_comments: 'Approval Comments',
    all_apply_ship_to_address: 'ShipTo 地址',
    all_apply_current_supply_center: 'Current Supply Center',
    all_apply_apply_supply_center: 'Apply Supply Center',
    all_apply_apply_distribution_mode: 'Apply Distribution Mode',
    all_apply_apply_reason: 'Apply Reason',
    all_apply_direct_method: 'Direct',
    all_apply_confirm_backup: 'Are you sure to cancel this application?',
    all_apply_confirm_backup_title: 'Cancellation of application',
    all_apply_confirm_invalid_status: 'Invalid Status',
    all_apply_confirm_No_right_to_cancel: 'No right to cancel',
    all_apply_cancel_time: 'Cancel Time',
    all_apply_Host: 'Host',
    all_apply_Customer: 'Customer',
    all_apply_Sales: 'Sales',
    clock_comments: 'Clock Comments',
    clock_comments_input: 'Please Input Clock Comments',
    submit_record_comments: 'submit',

    lto_history_list: 'Purchase order history',
    lto_history_order_wait_cusotmer_confirm: 'Pending customer confirm',
    lto_history_order_cusotmer_confirm: 'Customer Confirm',
    lto_history_order_cusotmer_cancel: 'Cancelled',
    lto_history_list_placeholder:
        'PO Number/SKU/Customer Name/ST Name/Preorder number',
    lto_history_list_st_name: 'ST Name',
    lto_history_list_st_number: 'ST Number',
    lto_history_list_customer_account: 'Customer Account',
    lto_history_list_recipient: 'Recipient',
    lto_history_list_po_number: 'PO Number',
    lto_history_list_total_sku: 'Total of {0}Pieces',
    lto_history_list_submit_time: 'Submit Time',
    lto_history_list_order_total_price: 'Total Price',
    lto_history_list_notification: 'Resend notification',
    lto_history_list_cancel_notification: 'Cancel Order',
    lto_history_list_cancel_reason: 'Cancel Reason',
    lto_history_list_cancel_reason_placeholder: 'Remark(optional)',
    lto_history_list_cancel_order_warning:
        'If you have any questions, please contact your sales representative in a timely manner.',
    lto_history_list_notification_send_success:
        'The notification has been sent successfully.',
    lto_history_list_resend_notification: 'Resend Notification',

    lto_history_detail: 'Purchase order history detail',
    lto_history_order_total_price: 'Total Amount',
    lto_history_detail_24_hour_expiration: '23:59 expiration',
    lto_history_detail_23_59_hour_expiration: '23:59',
    lto_history_detail_expiration_time: 'Expiration Time',
    lto_history_list_delivery_information: 'Delivery Information',
    lto_history_list_bt_number: 'BT Number',
    lto_history_list_invoice_heading: 'invoice heading',
    lto_history_list_invoice_address: 'invoice address',
    lto_history_detail_product_sku: 'Product Sku',
    lto_history_detail_product_name: 'Product Name',
    lto_history_detail_package_size: 'specification',
    lto_history_detail_list_price: 'List Price',
    lto_history_detail_discount_price: 'Discount Price',
    lto_history_detail_tfs_product: 'TFS Product',
    lto_history_detail_sc_product: 'SC Product',
    lto_history_detail_customer_cancel: 'Customer Cancel',
    lto_history_detail_order_timeout: 'Order Timeout',
    lto_history_detail_order_revoke: 'Order Revoke',
    lto_history_detail_confirm_time: 'Confirm Time',
    lto_history_detail_cancel_reason: 'Cancel Reason',
    lto_history_detail_total_quantity: 'Total {0} quantity',
    lto_history_detail_total_price: 'Total Price',
    lto_history_detail_promotion_codes: 'Promo Codes',
    lto_history_detail_order_timeout: 'Order timed out',
    lto_history_detail_order_information_sendto: 'Send order information to',
    lto_history_detail_preorder_number: 'Preorder Number',
    lto_history_detail_resend_channel_is_not_empty:
        'The resend notification option cannot be empty.',

    lto_purchase_order_line_up: 'Purchase Order',
    lto_purchase_order_line_down: 'upload proof order',
    lto_purchase_order_purchase_order_have_point:
        'Purchase order form and customers can enjoy loyalty points in the member center.',
    lto_purchase_order_tfs_customer: 'TFS User',
    lto_purchase_order_st_number: 'ST Number',
    lto_purchase_order_subject: 'Dept',
    lto_purchase_order_address: 'Address',
    lto_purchase_order_mobility: 'Thermo Fisher Mobile App',
    phoneNumber: 'SMS',
    defaultEmail: 'Email',
    retentionTime: 'Keep time until:',
    retentionTimeNotMoreThan14Days:
        'The retention period for pre-order forms should not exceed 14 days',
    lto_purchase_order_retention_time_not_empty: 'Keep until must not be empty',
    lto_purchase_order_retention_time_is_less_than_the_current_date:
        'The retention time is earlier than the current date',
    retention_time_is_more_than_the_current_date:
        'The maximum cannot exceed {0} days.',
    confirm_phoneNumber: 'SMS confirmation:',
    confirm_email: 'Email Confirmation:',
    please_confirm_info_is_correct:
        'Please confirm if the information is correct:',
    information_confirm: 'Confirm Information:',
    online_confirm: 'Confirm',
    information_na: 'NA',

    lto_history_detail_my_preorder_number: 'My purchase order number',
    lto_purchase_order_customer_confirmation_channel:
        'Customer confirm channel',
    lto_purchase_order_please_select_customer_confirmation_channel:
        'Please select the channels and information for customers to confirm their orders.',
    lto_purchase_order_upload_purchase_order_for_annual_agreement_customer:
        'Annual Agreement: Upload PO',
    lto_purchase_order_upload_purchase_order_for_non_annual_agreement_customer:
        'Non-Annual Agreement: Upload Contract',
    backup_supply_center_placeholder: 'Please select mobile numbe',
    backup_please_select_supply_center: 'Please select the supply center',
    customer_confirmation_channel_checked_sms_not_empty:
        'When the customer selects SMS as the preferred communication channel, the phone number must not be empty.',
    offline_platform_customer: 'Platform customer, subject to PO.',
    offline_platform_customer_add_attachment: 'Add Attachment',
    offline_platform_customer_information:
        'The uploaded vouchers and contracts will be reviewed by the relevant team.',
    lto_purchase_order_is_not_submit_btn_label: 'Return',
    lto_purchase_order_is_not_submit: 'The order cannot be submitted',
    lto_purchase_order_close_tip_info: 'Close',
    lto_purchase_order_please_advised: 'Please Advised',
    lto_purchase_order_please_advised_content1:
        'After you submit this order through the Spot Center, it will require customer confirmation. Once the order is confirmed, the customer will earn membership points in the Member Center.',
    lto_purchase_order_please_advised_content21:
        'Customers can use the mobile app to ',
    lto_purchase_order_please_advised_content22:
        'Thermo Fisher Scientific, SMS ',
    lto_purchase_order_please_advised_content23: 'or ',
    lto_purchase_order_please_advised_content24: 'Email ',
    lto_purchase_order_please_advised_content25:
        'receive order confirmation notifications',
    lto_purchase_order_please_advised_content3:
        'Note: SMS and email notifications do not require customer login and can be confirmed with one click.',
    lto_purchase_order_not_remind: 'Do not remind again',
    lto_purchase_order_timer: '({0}s)',

    offline_order_successfully_upload: 'Successfully Upload',
    lto_purchase_upload_file: 'Order submission file({0})',
    lto_purchase_upload_file_delete: 'Delete',
    lto_purchase_upload_file_image_too_large:
        'The uploaded image cannot exceed {0}.',
    lto_purchase_upload_file_bad_file_format:
        'The uploaded image has an incorrect format. allowed file format:[jpg, jpeg, png, pdf, doc, docx]',
    lto_purchase_upload_file_confirm_upload_tag:
        'Confirm upload of purchase order voucher.',
    lto_purchase_order_customer_confirmation_link: 'Customer confirm link',
    lto_purchase_order_copy_confirmation_link: 'Copy confirm link',
    lto_purchase_order_copy_confirmation_link_to_customer_confirm_lto:
        'You can copy the link and send it to the customer to confirm this pre-order',
    lto_purchase_order_copy_link: 'Copy Link',

    upload_image_too_large: 'The file size exceeds the limit',

    order_detail_purchase_order_voucher: 'purchase order voucher',
    order_detail_purchase_order_voucher_for_po:
        'Annual Agreement: Order Proof (PO)',
    order_detail_purchase_order_voucher_for_contract:
        'Non-Annual Agreement: Order Proof (Contract)',
    order_detail_purchase_order_voucher_preview: 'Download',
    purchase_order_upload_here:
        'Click here to take purchase order and upload credentials',
    retentionTime_tip: '11:59 PM',
    order_does_not_exist: 'Order does not exist',
    order_not_correct: 'Error retrieving order information',
    welcome_to_website: 'Welcome to supply center system!',
    user_account_unauthorized:
        'You currently do not have permission to access this system. If you need to request access, Please contact SupplyCenter@thermofisher.onmicrosoft.com.',
    unauthorized_connect_email: 'SupplyCenter@thermofisher.onmicrosoft.com',

    offline_reminder_message1:
        'If you choose to assist the customer with order placement, when the order amount exceeds the exemption threshold, you are required to upload the following proof of order placement at the time of order submission.',
    offline_reminder_message2:
        '1.Please comply with the "Sales Order Placement System" to ensure that all required supporting documents are provided for order placement, and a dual-signed sales contract with the customer is required.',
    offline_reminder_message3:
        '2.When there is a change in the shipping address, please provide the required address confirmation documents in accordance with the company Delivery Address Change Policy',

    dealer_customer_info:
        'You are a distributor of the company. According to company policy, please place your orders through the official website or offline channels.',

    new_offline_reminder_message1:
        'The upload-voucher order channel is only applicable for end-users or advance-payment agents placing orders under RMB 60,000 without supporting documents. According to company compliance policies, if the customer is a distributor (for orders of any amount), or if an end-user or advance-payment agent places a single order exceeding the document-exemption threshold (i.e., RMB 60,000),',

    new_offline_reminder_message1_part2:
        'Please provide supplemental user purchase order / contract.',

    new_offline_reminder_message2:
        '1.Please comply with the "Thermo Fisher Scientific China Sales Process – Order Entry Management System" to ensure submission of required order entry supporting documents (e.g., sales contract/PO with dual seals).',

    new_offline_reminder_message3:
        '2.When changing the shipping address, please provide the required address confirmation documents in accordance with the company Shipping Address Change Policy.',

    offline_ordertotal_limit_exceed_message1:
        'According to the "Thermo Fisher China Sales Process - Order Entry Management System", for orders exceeding 60,000 RMB, entry into the system is not permitted. You may return to the shopping cart to make adjustments, or prepare the following order entry documents for offline order processing. Please double-check the total order amount before submission.',

    offline_ordertotal_limit_exceed_message2:
        '1.Please comply with the "Thermo Fisher Scientific China Sales Process - Order Entry Management System" to ensure the submission of required order entry supporting documents (e.g., sales contract/PO with two official seals).',

    offline_ordertotal_limit_exceed_message3:
        '2.When the shipping address changes, please provide the required address confirmation documents in accordance with the company Delivery Address Change Policy.',
    upload_file_format: 'Allowed file format:{0}',
    PromoDetails: '促销优惠',
    Savings: '立省',
    BestDiscount: '最优惠',
    MinOrderQty: '起购量',
    ProductItems: '个',
    GoToActivity: '前往活动页面',
    COPYPROMOTOUSE: '复制促销代码至购物车使用',
    OpenActivityPageFailed: 'Open activity page failed',
    oem_custom_order_product: 'Custom order product',
    oem_product_promo_not_supported:
        'Custom order products cannot use promotion codes online.',
    oem_mixed_checkout_not_supported:
        'The cart contains custom order products. Please check out custom order products and regular products separately.',
    oem_order_remark_required:
        'Please enter remarks for the custom order product.',
    oem_order_remark_placeholder:
        'Please enter the product unit price and promotion code. If there is no promotion code, state No promotion code.',
};

export default en_US;
